import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import { useIntl } from 'react-intl';
import LinkTab from './link-tab';
import { ACTIVE_COLOR } from '../../utils/constants';

const a11yProps = (index) => {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

const useStyles = makeStyles({
  indicator: {
    backgroundColor: ACTIVE_COLOR,
    borderTopLeftRadius: 15,
    borderTopRightRadius: 15,
    height: 5,
    marginLeft: 12
  },
});

const TabsHeader = ({ router, location }) => {
    const classes = useStyles();
    const { formatMessage } = useIntl();
    const [value, setValue] = useState(`/${location.pathname.split('/')[1]}`);

    const handleChange = (event, newValue) => {
      setValue(newValue);
    };

    return (
        <Tabs
            value={value}
            onChange={handleChange}
            classes={location.pathname.includes(value) ? { indicator: classes.indicator}: ''}
        >
            <LinkTab 
                label={formatMessage({id:"app.nav.dashboard", defaultMessage:"Dashboard"})} 
                {...a11yProps(0)} 
                router={router}
                iconLabel="dashboard"
                location={location} 
                value="/"
                minWidth={true}
              />
            <LinkTab
                label={formatMessage({id:"app.topics", defaultMessage:"Topics"})} 
                {...a11yProps(2)} 
                router={router} 
                iconLabel="topics"
                value="/topics" 
                location={location}/>
            {/* <LinkTab
                label={formatMessage({id:"app.patterns", defaultMessage:"Patterns"})} 
                {...a11yProps(2)} 
                router={router} 
                iconLabel="patterns"
                value="/patterns" 
                location={location}/> */}
            <LinkTab
                label="Conversations" 
                {...a11yProps(1)} 
                router={router} 
                iconLabel="conversations"
                location={location} 
                value="/conversations" />    
        </Tabs>
    );
}

export default TabsHeader;